import { Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'

export const C1MenuTheme: Components<Theme>['MuiMenu'] = {
    defaultProps: {
        transitionDuration: 100,
    },
    styleOverrides: {
        paper: ({ theme }) => theme.unstable_sx({
            boxShadow: 3,
            borderRadius: C1BorderRadius.large,
        }),
    },
}

export const C1MenuItemTheme: Components<Theme>['MuiMenuItem'] = {
    defaultProps: {
        role: 'menuitem',
    },
    styleOverrides: {
        root: ({ theme }) => ({
            ...theme.unstable_sx({
                fontWeight: 500,

                // WCAG 2.2 AA compliant styles for menu items
                transition: 'background-color 0.2s',

                '&:hover': {
                    backgroundColor: 'primary.extraLight',
                    color: 'primary.dark',
                },

                '&:focus-visible': {
                    outline: '2px solid',
                    outlineColor: 'primary.main',
                    outlineOffset: '-2px',
                    backgroundColor: 'primary.extraLight',
                },

                '&.Mui-focusVisible': {
                    outline: '2px solid',
                    outlineColor: 'primary.main',
                    outlineOffset: '-2px',
                    backgroundColor: 'primary.extraLight',
                },

                '&:first-of-type': {
                    borderTopLeftRadius: C1BorderRadius.large,
                    borderTopRightRadius: C1BorderRadius.large,
                },

                '&:last-of-type': {
                    borderBottomLeftRadius: C1BorderRadius.large,
                    borderBottomRightRadius: C1BorderRadius.large,
                },

                '& .MuiListItemIcon-root': {
                    minWidth: '24px',
                },
            }),
        }),
    },
}
